import { Button } from "@/components/ui/button";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { useConfigStore } from "@/store/use-config-store";
import { isPWA } from "@/utils/util";
import { createFileRoute } from "@tanstack/react-router";
import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useLng } from "@/hooks/use-lng";

export const Route = createFileRoute("/_app/update")({
  head: () => appTitleHead("update-title"),
  component: UpdatePage
});

function UpdatePage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");
  const [settings] = useConfigStore(useShallow((state) => [state.settings]));
  const [copied, setCopied] = useState(false);

  const url =
    settings && lng ? `${settings?.appUrlOverride}/membersapp/update` : undefined;

  const handleCopy = () => {
    if (!url) return;
    void navigator.clipboard.writeText(url);
    setCopied(true);
  };

  const buttonText = copied ? (
    <div className="flex gap-4">
      {t("update-copied")} <Check className="h-5 w-5 stroke-[3px]" />
    </div>
  ) : (
    <div className="flex gap-4">
      {url?.slice(0, 27)}... <Copy className="h-5 w-5" />
    </div>
  );

  return (
    <div>
      <h1 className="text-left md:text-left">{t("update-title")}</h1>
      {isPWA() ? (
        <>
          <p>{t("update-description")}</p>
          {url ? (
            <Button
              className={`mt-4 w-full py-6 md:w-fit ${copied ? "bg-green-600 text-slate-100 hover:bg-green-600" : ""}`}
              onClick={handleCopy}
              aria-label={t("update-copy")}
            >
              {buttonText}
            </Button>
          ) : null}
        </>
      ) : (
        <p>{t("update-finished")}</p>
      )}
    </div>
  );
}
